import React from 'react';
import { FormattedMessage } from 'react-intl';
import { components } from 'react-select';
import PropTypes from 'prop-types';

export const CustomMenuList = (props, isOptionError) => {
  return (
    <components.MenuList {...props}>
      {!isOptionError && props.children}
      {isOptionError && (
        <div className='p-3 gutter'>
          <FormattedMessage
            id="search.activity-input.no-activity"
            defaultMessage="We don't recognize that activity. Try describing it differently" />
        </div>
      )}
    </components.MenuList>
  );
};

CustomMenuList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};
